"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchExclusive = exports.createSearchQuery = void 0;
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var effects_1 = require("redux-saga/effects");
var SearchApi_1 = require("@/api/remote/public/SearchApi");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
var IconType_1 = require("@/pages/search/states/IconType");
var searchResponseToSearchExclusiveResult_1 = require("@/pages/exclusive/transformers/searchResponseToSearchExclusiveResult");
exports.createSearchQuery = function (priceMin, priceMax, type, keyword, searchResultType, searchResultId, sortByStr, languageId, currencyId, pageNumber, pageSize) {
    var sortPcs = (!sortByStr ? 'updateddate-desc' : sortByStr).split('-');
    var sortBy = sortPcs[0];
    var sortByIsDesc = sortPcs[1] === 'desc';
    var sizeType = ['netsize', 'pricepersqft'].indexOf(sortBy) >= 0 ? 'S' : '';
    return {
        languageId: languageId,
        currencyId: currencyId,
        keyword: keyword,
        pageNumber: pageNumber,
        pageSize: pageSize,
        priceMin: type === SfilterTypeGroup_1.SfilterType.BUY ? priceMin / 10000 : priceMin,
        priceMax: type === SfilterTypeGroup_1.SfilterType.BUY ? priceMax / 10000 : priceMax,
        area: '',
        sizeType: sizeType,
        sizeMin: 0,
        sizeMax: 0,
        bedroomMin: 0,
        bedroomMax: 20,
        listingTypeId: SfilterTypeGroup_1.SfilterType.toListingPurposeType(type),
        layout: '',
        districtName: '',
        district: '',
        searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.Search,
        searchResultType: searchResultType,
        searchResultId: searchResultId,
        iconType: IconType_1.IconType.Exclusive,
        sortBy: sortBy,
        orderBy: sortByIsDesc ? 'desc' : 'asc',
    };
};
exports.searchExclusive = function (priceMin, priceMax, type, keyword, searchResultType, searchResultId, sortBy, pageNumber, pageSize) {
    var languageId, currencyId, searchQuery, searchResponse, newResultPage;
    if (pageSize === void 0) { pageSize = 9; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 1:
                languageId = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 2:
                currencyId = _a.sent();
                return [4 /*yield*/, effects_1.call(exports.createSearchQuery, priceMin, priceMax, type, keyword, searchResultType, searchResultId, sortBy, languageId, currencyId, pageNumber, pageSize)];
            case 3:
                searchQuery = _a.sent();
                return [4 /*yield*/, effects_1.call(SearchApi_1.searchQueryApi, searchQuery)];
            case 4:
                searchResponse = _a.sent();
                return [4 /*yield*/, effects_1.call(searchResponseToSearchExclusiveResult_1.searchResponseToSearchExclusiveResult, searchResponse, type)];
            case 5:
                newResultPage = _a.sent();
                return [2 /*return*/, newResultPage];
        }
    });
};
